<div class="panel panel-default">
  <ng-content select="ap-card-body"></ng-content>
  <ng-content select="ap-card-footer"></ng-content>
</div>

